/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Share
 */
export interface Share  {
    /**
     * 
     * @type {number}
     * @memberof Share
     */
    ownerId?: number;
    /**
     * 
     * @type {number}
     * @memberof Share
     */
    viewId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Share
     */
    sharedWith?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Share
     */
    sharedBy?: number;
}

/**
 * Check if a given object implements the Share interface.
 */
export function instanceOfShare(value: object): value is Share {
    return true;
}

export function ShareFromJSON(json: any): Share {
    return ShareFromJSONTyped(json, false);
}

export function ShareFromJSONTyped(json: any, ignoreDiscriminator: boolean): Share {
    if (json == null) {
        return json;
    }
    return {
        
                  'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
                  'viewId': json['viewId'] == null ? undefined : json['viewId'],
              'sharedWith': json['sharedWith'] == null ? undefined : json['sharedWith'],
                  'sharedBy': json['sharedBy'] == null ? undefined : json['sharedBy'],
    };
}

export function ShareToJSON(json: any): Share {
    return ShareToJSONTyped(json, false);
}

export function ShareToJSONTyped(value?: Share | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ownerId': value['ownerId'],
        'viewId': value['viewId'],
        'sharedWith': value['sharedWith'] == null? value['sharedWith']: value['sharedWith'],
        'sharedBy': value['sharedBy'],
    };
}


